import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFound {
  private router = inject(Router);
  goHome(): void {
    this.router.navigate(['/']);
  }

  private languageService = inject(LanguageService);
  currentLocale = signal<string>('en');

  toggleLanguage() {
    this.languageService.toggleLocale();
  }
  ngOnInit() {
    this.currentLocale.set(this.languageService.getCurrentLocale());
  }
}
